module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAAWElEQVRYhWNgGAWjYKQDRgYGBgb7wC2rGRgYQ/AplBBjPzG1w9SCGEMF0g1OMD+/T0jtGsbDDKFMRDqUZmDUAaMOGHXAqANGHTDqgFEHjDpg1AGjYBSMAgDHBQooYUZEBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/incab/common/LanguageSelector/icons/fr.png
// module id = ./src/incab/common/LanguageSelector/icons/fr.png
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons